<template>
  <div
    class="gest_risorse"
    :style="
      '--righe_disp_sched: ' +
      (colore_righe ? '#E1E6FF' : 'white') +
      '; --nome_vis: ' +
      (nome_op == 1 ? 'inline' : 'none') +
      '; --cod_art_vis: ' +
      (fase.sw_cod_articolo == 1 ? 'inline' : 'none') +
      '; --des_art_vis: ' +
      (fase.sw_des_articolo == 1 ? 'inline' : 'none') +
      '; --cod_com_vis: ' +
      (fase.sw_cod_commessa == 1 ? 'inline' : 'none') +
      '; --cod_num_vis: ' +
      (fase.sw_numero_pezzi == 1 ? 'inline' : 'none')
    "
  >
    <main>
      <slot name="bottoni"> </slot>
      <div class="tabellaSch">
        <table id="diagram_table">
          <thead>
            <tr />
            <tr />
          </thead>
          <tbody @click="alClick"></tbody>
        </table>
      </div>
    </main>
    <v-progress-linear
      indeterminate
      color="cyan"
      v-if="caricamento_dati"
      id="progress"
    >
    </v-progress-linear>
    <!-- DIALOG CAMBIO COLORE -->
    <v-dialog v-model="vedi_cambio_colore" width="unset">
      <v-card>
        <v-toolbar
          class="white--text"
          color="indigo"
          style="position: sticky; top: 0px; z-index: 1"
          dense
        >
          <v-toolbar-title>Cambia colori</v-toolbar-title>
          <v-spacer></v-spacer>
          <!-- Bottone di salvataggio -->
          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <v-btn @click="salvaColore" small v-bind="attrs" v-on="on">
                <v-icon color="success"> mdi-floppy </v-icon>
              </v-btn>
            </template>
            <span>Conferma</span>
          </v-tooltip>
          <v-spacer></v-spacer>
          <!-- Bottone di chiusura -->
          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                @click="vedi_cambio_colore = false"
                small
                v-bind="attrs"
                v-on="on"
              >
                <v-icon color="error"> mdi-close </v-icon>
              </v-btn>
            </template>
            <span>Chiudi</span>
          </v-tooltip>
        </v-toolbar>
        <v-card-text class="mt-5 mb-0 pb-5">
          <h2>Colore sfondo:</h2>
          <v-color-picker
            @update:color="
              item.colore_sfondo
                ? item.colore_sfondo.hex
                  ? (item.colore_sfondo = item.colore_sfondo.hex)
                  : '#000000'
                : '#000000'
            "
            v-model="item.colore_sfondo"
            class="ma-2"
            dark
            hide-canvas
            hide-inputs
            hide-sliders
            hide-mode-switch
            :swatches="swatches"
            show-swatches
          ></v-color-picker>
          <h2>Colore testo:</h2>
          <v-color-picker
            @update:color="
              item.colore_testo
                ? item.colore_testo.hex
                  ? (item.colore_testo = item.colore_testo.hex)
                  : '#000000'
                : '#000000'
            "
            v-model="item.colore_testo"
            class="ma-2"
            hide-canvas
            dark
            hide-inputs
            hide-sliders
            hide-mode-switch
            :swatches="swatches_text"
            show-swatches
          ></v-color-picker>
        </v-card-text>
      </v-card>
    </v-dialog>

    <!-- DIALOG PER CAMBIARE DATA E ORA DEL TASK -->
    <v-dialog v-model="dialog_cambio_date" max-width="700px">
      <v-card>
        <v-toolbar
          class="white--text"
          color="indigo"
          style="position: sticky; top: 0px; z-index: 1"
          dense
        >
          <v-toolbar-title>Modifica data e orario del viaggio</v-toolbar-title>
          <v-spacer></v-spacer>
          <!-- Bottone di salvataggio -->
          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <v-btn @click="cambiaData" small v-bind="attrs" v-on="on">
                <v-icon color="success"> mdi-floppy </v-icon>
              </v-btn>
            </template>
            <span>Salva</span>
          </v-tooltip>
          <v-spacer></v-spacer>
          <!-- Bottone di chiusura -->
          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                @click="
                  dialog_cambio_date = false;
                  id_task_cambio_date = null;
                "
                small
                v-bind="attrs"
                v-on="on"
              >
                <v-icon color="error"> mdi-close </v-icon>
              </v-btn>
            </template>
            <span>Chiudi</span>
          </v-tooltip>
        </v-toolbar>
        <v-card-text class="mt-5 mb-0 pb-5">
          <h2 class="mt-5">
            <v-row align="center" justify="center">
              <v-col cols="3">
                <v-text-field
                  v-model="data_inizio_mod"
                  hide-details
                  type="date"
                  label="Data inizio"
                >
                </v-text-field>
              </v-col>
              <v-col cols="2">
                <v-text-field
                  v-model="ora_inizio_mod"
                  hide-details
                  type="time"
                  label="Ora inizio"
                >
                </v-text-field> </v-col></v-row
            ><v-row align="center" justify="center">
              <v-col cols="3">
                <v-text-field
                  v-model="data_fine_mod"
                  hide-details
                  type="date"
                  label="Data fine"
                >
                </v-text-field></v-col
              ><v-col cols="2">
                <v-text-field
                  v-model="ora_fine_mod"
                  hide-details
                  type="time"
                  label="Ora fine"
                >
                </v-text-field> </v-col
            ></v-row>
          </h2>
        </v-card-text>
      </v-card>
    </v-dialog>
    <!-- DIALOG CAMBIO OPERATORE -->
    <v-dialog v-model="vedi_num_oper" max-width="700px">
      <v-card>
        <v-toolbar
          class="white--text"
          color="indigo"
          style="position: sticky; top: 0px; z-index: 1"
          dense
        >
          <v-toolbar-title>Cambio numero operatori</v-toolbar-title>
          <v-spacer></v-spacer>
          <!-- Bottone di salvataggio -->
          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <v-btn @click="salvaNumOperatori" small v-bind="attrs" v-on="on">
                <v-icon color="success"> mdi-floppy </v-icon>
              </v-btn>
            </template>
            <span>Salva e rischedula</span>
          </v-tooltip>
          <v-spacer></v-spacer>
          <!-- Bottone di chiusura -->
          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                @click="
                  vedi_num_oper = false;
                  commessa = '';
                  num_operatori = '';
                "
                small
                v-bind="attrs"
                v-on="on"
              >
                <v-icon color="error"> mdi-close </v-icon>
              </v-btn>
            </template>
            <span>Chiudi</span>
          </v-tooltip>
        </v-toolbar>
        <v-card-text class="mt-5 mb-0 pb-5">
          <v-text-field
            background-color="#ffffff"
            dense
            height="50px"
            label="Numero operatori abbinati alla fase di lavoro"
            hide-details
            outlined
            style="
              display: inline-block;
              font-size: 35px;
              font-weight: bold;
              line-height: 35px;
              max-width: 400px;
              padding: 0px;
            "
            type="number"
            v-model="num_operatori"
          >
          </v-text-field>
        </v-card-text>
      </v-card>
    </v-dialog>

    <SnackbarQV ref="SnackbarQV" />
  </div>
</template>

<script>
import Calendar from "@/classes/Calendar.js";
import SnackbarQV from "@/components/TOOLS/SnackbarQV.vue";
import alasql from "alasql";

export default {
  name: "Diagram",
  components: { SnackbarQV },
  props: [
    "prima_col",
    "nome_key",
    "zoom_sched",
    "colore_righe",
    "nome_op",
    "fase",
    "data_inizio_filt",
    "data_fine_filt",
  ],
  data() {
    return {
      caricamento_dati: false,
      CALENDAR: new Calendar(),
      attivita: new Array(),
      tasks: new Array(),
      operatori: new Array(),
      info: new Array(),
      commessa: "",
      id_tabella: "tabella " + this.prima_col,
      spostamento: true,
      competenze_task: "",
      oper_destinatario: "",
      vedi_cambio_colore: false,
      vedi_num_oper: false,
      dialog_cambio_date: false,
      data_inizio_mod: new Date(),
      ora_inizio_mod: null,
      data_fine_mod: new Date(),
      ora_fine_mod: null,
      id_task_cambio_date: null,
      num_operatori: "",
      item: {
        colore_sfondo: "",
        colore_testo: "",
      },
      swatches: [
        ["#C2EDF9", "#93EB74"],
        ["#FFB7B2", "#FFDAC1"],
        ["#E2F0CB", "#FAEE67"],
      ],
      swatches_text: [
        ["#000000", "#FF0000"],
        ["#199C1A", "#005500"],
        ["#0000FF", "#000055"],
      ],
    };
  },
  async mounted() {
    console.log("mounted");
    await this.getJsonDalServer();
    await this.CALENDAR.setZoom(this.zoom_sched);
    this.$nextTick(async () => {
      await this.CALENDAR.build(
        this[this.prima_col],
        this.tasks,
        this.nome_key,
        this.prima_col,
        this.data_inizio_filt,
        this.data_fine_filt,
        this.info
      );
      console.log("da build: ", this[this.prima_col]);
      this.$emit("fine-build");
    });

    document
      .getElementById("diagram_table")
      .addEventListener("semaforo_spostamento", this.noSpostamento);
  },

  beforeDestroy() {
    if (document.getElementById("diagram_table")) {
      document
        .getElementById("diagram_table")
        .removeEventListener("semaforo_spostamento", this.noSpostamento);
    }
  },

  methods: {
    async cambiaData() {
      let ora_inizio =
        this.ora_inizio_mod.split(":")[0] +
        ":" +
        this.ora_inizio_mod.split(":")[1];
      let ora_fine =
        this.ora_fine_mod.split(":")[0] + ":" + this.ora_fine_mod.split(":")[1];
      await new Promise((resolve) => {
        alasql(
          `ATTACH INDEXEDDB DATABASE commessa_db; \
            UPDATE commessa_db.task SET data_inizio = "${this.data_inizio_mod}T${ora_inizio}:00", data_fine = "${this.data_fine_mod}T${ora_fine}:00", modificato = 1 WHERE id_task = ${this.id_task_cambio_date}`,
          [],
          function () {
            resolve();
          }
        );
      });

      console.log(
        this.data_inizio_mod + "T" + ora_inizio,
        "///",
        this.data_fine_mod + "T" + ora_fine,
        this.id_task_cambio_date
      );
      this.data_inizio_mod = null;
      this.ora_inizio_mod = null;
      this.data_fine_mod = null;
      this.ora_fine_mod = null;
      this.dialog_cambio_date = false;
      this.CALENDAR.build(
        this[this.prima_col],
        this.tasks,
        this.nome_key,
        this.prima_col,
        this.data_inizio_filt,
        this.data_fine_filt,
        this.info
      );
    },
    async alClick(event) {
      let path = event.composedPath();
      for (let i = 0; i < path.length; i++) {
        if (path[i].tagName.toLowerCase() === "body") {
          return;
        }
        let attributo = path[i].getAttribute("bottone");
        //let operatori_attuali_str = "";
        let data_inizio = [];
        let data_fine = [];
        // Variabili per + e - mezz'ora
        let minuti = "";
        let ore = "";
        switch (attributo) {
          case "Cambio_colore":
            this.vedi_cambio_colore = true;
            this.commessa = path[i].getAttribute("commessa");
            this.item.colore_sfondo = path[i].getAttribute("colore_sfondo");
            this.item.colore_testo = path[i].getAttribute("colore_testo");
            break;
          case "num_operatori":
            // Serve chiamata per conoscere tutti gli operatori possibili
            this.commessa = path[i].getAttribute("commessa");
            this.vedi_num_oper = true;
            break;
          case "cambia_date":
            console.log(path[i].getAttribute("id_task"));
            this.id_task_cambio_date = path[i].getAttribute("id_task");
            console.log(path[i].getAttribute("data_inizio"));
            data_inizio = path[i].getAttribute("data_inizio").split("T");
            data_fine = path[i].getAttribute("data_fine").split("T");
            this.data_inizio_mod = data_inizio[0];
            this.ora_inizio_mod = data_inizio[1];
            this.data_fine_mod = data_fine[0];
            this.ora_fine_mod = data_fine[1];
            console.log(data_inizio, data_fine);
            this.dialog_cambio_date = true;
            break;
          case "minus_half":
            console.log(path[i].getAttribute("id_task"));
            this.id_task_cambio_date = path[i].getAttribute("id_task");
            console.log(path[i].getAttribute("data_inizio"));
            data_inizio = path[i].getAttribute("data_inizio").split("T");
            data_fine = path[i].getAttribute("data_fine").split("T");
            this.data_inizio_mod = data_inizio[0];
            this.ora_inizio_mod = data_inizio[1];
            this.data_fine_mod = data_fine[0];
            this.ora_fine_mod = data_fine[1];
            ore = this.ora_fine_mod.split(":")[0] * 1;
            minuti = this.ora_fine_mod.split(":")[1] * 1 - 30;
            if (minuti < 0) {
              minuti = 60 + minuti * 1;
              ore = ore * 1 - 1;
            }
            if (minuti < 10) {
              minuti = "0" + minuti;
            }
            this.ora_fine_mod = ore + ":" + minuti + ":00";
            console.log(this.ora_fine_mod);
            this.cambiaData();
            break;
          case "plus_half":
            console.log(path[i].getAttribute("id_task"));
            this.id_task_cambio_date = path[i].getAttribute("id_task");
            console.log(path[i].getAttribute("data_inizio"));
            data_inizio = path[i].getAttribute("data_inizio").split("T");
            data_fine = path[i].getAttribute("data_fine").split("T");
            this.data_inizio_mod = data_inizio[0];
            this.ora_inizio_mod = data_inizio[1];
            this.data_fine_mod = data_fine[0];
            this.ora_fine_mod = data_fine[1];
            ore = this.ora_fine_mod.split(":")[0] * 1;
            minuti = this.ora_fine_mod.split(":")[1] * 1 + 30;
            if (minuti >= 60) {
              minuti = minuti * 1 -60;
              ore = ore * 1 + 1;
            }
            if (minuti < 10) {
              minuti = "0" + minuti;
            }
            this.ora_fine_mod = ore + ":" + minuti + ":00";
            console.log(this.ora_fine_mod);
            this.cambiaData();
            break;
        }
      }

      console.log(this.operatori_attuali);
    },

    /*  async formatListaOp(operatori_att_str) {
      let operatori = new Array();
      this.operatori_attuali = operatori_att_str.split(",").map(Number);
      await new Promise((resolve) => {
        alasql(
          `ATTACH INDEXEDDB DATABASE commessa_db; \
            SELECT * FROM commessa_db.operatori`,
          [],
          function (res) {
            for (let i = 0; i < res[1].length; i++) {
              operatori[i] = res[1][i];
            }
            resolve();
          }
        );
      });
      for (let t = 0; t < operatori.length; t++) {
        for (let k = 0; k < this.operatori_attuali.length; k++) {
          if (this.operatori_attuali[k] == operatori[t].id_personale) {
            this.operatori_attuali[k] = operatori[t].cognome;
          }
        }
      }
    }, */

    async getJsonDalServer() {
      let that = this;
      let db_exist = true;
      try {
        await new Promise((resolve) => {
          var request = indexedDB.open("commessa_db", this.CALENDAR.version_db);
          request.onerror = function () {
            db_exist = false;
            resolve();
          };
          request.onsuccess = function (event) {
            that.CALENDAR.db_connection = event.target.result;
            resolve();
          };
          request.onupgradeneeded = function (event) {
            event.target.transaction.abort();
            db_exist = false;
            resolve();
          };
        });
      } catch {
        console.log("Database non presente, caricamento dati dal server.");
      }
      if (!db_exist) {
        this.caricamento_dati = true;
        var request = {
          controller: "Schedulatore",
          method: "POST",
          richiesta: {
            action: "lista",
            token: localStorage.getItem("user_token"),
            data_inizio: "2022-01-21T08:00:00",
          },
        };

        return this.$store
          .dispatch("api", request)
          .then((res) => {
            if (res.status == 200) {
              this.caricamento_dati = false;
              this.attivita = res.data.attivita;
              this.tasks = res.data.jobs;
              this.operatori = res.data.operatori;
              this.info = res.data.info;
              console.log(this.attivita);
              this.CALENDAR.gestore_db(
                this.attivita,
                this.tasks,
                this.operatori,
                this.info
              );
            }

            return true;
          })
          .catch((err) => {
            console.log("ERRORE");
            console.log(err);
            return false;
          });
      }
    },

    async switchView(
      zoom,
      prima_colonna,
      key_ident,
      data_inizio_filt,
      data_fine_filt
    ) {
      this.CALENDAR.setZoom(zoom);
      await this.CALENDAR.build(
        this[prima_colonna],
        this.tasks,
        key_ident,
        prima_colonna,
        data_inizio_filt,
        data_fine_filt,
        this.info
      );
      //_filt = data_inizio_filt;
      //this.data_fine_filt = data_fine_filt;
      console.log(data_inizio_filt, data_fine_filt);
    },

    deleteDB() {
      var DBDeleteRequest = window.indexedDB.deleteDatabase("commessa_db");
      DBDeleteRequest.onerror = function () {
        console.log("Error deleting database.");
      };

      DBDeleteRequest.onsuccess = function () {
        console.log("Database deleted successfully");
      };
    },

    async salvaColore() {
      //Serve chiamata per set colore
      await new Promise((resolve) => {
        alasql(
          `ATTACH INDEXEDDB DATABASE commessa_db; \
            UPDATE commessa_db.task SET colore_sfondo = "${this.item.colore_sfondo}", colore_testo = "${this.item.colore_testo}" WHERE id_riferimento = ${this.commessa}`,
          [],
          function () {
            resolve();
          }
        );
      });
      console.log(
        this.commessa,
        this.item.colore_sfondo,
        this.item.colore_testo
      );

      console.log(this.zoom_sched);
      this.vedi_cambio_colore = false;
      console.log("Token: ", localStorage.getItem("user_token"));
      var request = {
        controller: "Schedulatore",
        method: "POST",
        richiesta: {
          action: "savecolore",
          token: localStorage.getItem("user_token"),
          commessa: this.commessa,
          colore_sfondo: this.item.colore_sfondo,
          colore_testo: this.item.colore_testo,
        },
      };

      return this.$store
        .dispatch("api", request)
        .then((res) => {
          if (res.status == 204) {
            this.$refs.SnackbarQV.print("success", "Salvataggio effettuato.");
          }

          this.CALENDAR.setZoom(this.zoom_sched);
          this.CALENDAR.build(
            this[this.prima_col],
            this.tasks,
            this.nome_key,
            this.prima_col,
            this.data_inizio_filt,
            this.data_fine_filt,
            this.info
          );
        })
        .catch((err) => {
          console.log("ERRORE");
          console.log(err);
        });
    },

    // Da testare molto bene!
    salvaNumOperatori() {
      console.log(this.commessa, this.num_operatori);

      var request = {
        controller: "Schedulatore",
        method: "POST",
        richiesta: {
          action: "modificaoperatori",
          token: localStorage.getItem("user_token"),
          id_riferimento: parseInt(this.commessa),
          numero_operatori: parseInt(this.num_operatori),
          operatori_specifici: "",
        },
      };

      return this.$store
        .dispatch("api", request)
        .then((res) => {
          if (res.status == 200 || res.status == 204) {
            this.$refs.SnackbarQV.print("success", "Salvataggio effettuato.");

            this.deleteDB();
            window.location.reload();
            /* this.getJsonDalServer();
            this.CALENDAR.setZoom(this.zoom_sched);
            this.CALENDAR.build(
              this[this.prima_col],
              this.tasks,
              this.nome_key,
              this.prima_col,
              this.data_inizio_filt,
              this.data_fine_filt
            ); */
          }
        })
        .catch((err) => {
          console.log("ERRORE");
          console.log(err);
        });
    },

    async noSpostamento(e) {
      this.spostamento = e.detail.spostamento;
      this.competenze_task = e.detail.competenze;
      this.oper_destinatario = e.detail.cognome;
      console.log(this.spostamento);
      if (!this.spostamento) {
        this.$refs.SnackbarQV.print(
          "orange",
          "L'operatore " +
            this.oper_destinatario +
            " non possiede le seguenti competenze: " +
            this.competenze_task
        );
        this.spostamento = true;
      } else if (this.spostamento == "quasi") {
        this.$refs.SnackbarQV.print(
          "orange",
          "Lavorazione con addetti multipli, la data di inizio non può essere modificata."
        );
        this.spostamento = true;
      }
    },
  },
};
</script>

<style>
.gest_risorse * {
  scrollbar-color: #3f51b5 transparent;
  scrollbar-width: normal;
}

.gest_risorse *::-webkit-scrollbar {
  width: 20px !important;
  height: 20px !important;
}
.gest_risorse *::-webkit-scrollbar-track {
  background-color: transparent;
}
.gest_risorse *::-webkit-scrollbar-thumb {
  background-color: #3f51b5;
}
.gest_risorse *::-webkit-scrollbar-button:single-button {
  background-size: 16px 16px;
  display: block;
  background-repeat: no-repeat;
  height: 20px;
  width: 20px;
}

.gest_risorse *::-webkit-scrollbar-button:single-button:vertical {
  background-position: center 1px;
  height: 10px;
}

.gest_risorse *::-webkit-scrollbar-button:single-button:vertical:decrement {
  background-image: url("data:image/svg+xml;utf8,<svg xmlns='http://www.w3.org/2000/svg' width='100' height='100' fill='rgb(63, 81, 181)'><polygon points='50,00 0,50 100,50'/></svg>");
}

.gest_risorse *::-webkit-scrollbar-button:single-button:vertical:increment {
  background-image: url("data:image/svg+xml;utf8,<svg xmlns='http://www.w3.org/2000/svg' width='100' height='100' fill='rgb(63, 81, 181)'><polygon points='50,50 0,00 100,00'/></svg>");
}

.gest_risorse *::-webkit-scrollbar-button:single-button:horizontal {
  background-position: 1px center;
  width: 10px;
}

.gest_risorse *::-webkit-scrollbar-button:single-button:horizontal:increment {
  background-image: url("data:image/svg+xml;utf8,<svg xmlns='http://www.w3.org/2000/svg' width='100' height='100' fill='rgb(63, 81, 181)'><polygon points='00,00 00,100 50,50'/></svg>");
}

.gest_risorse *::-webkit-scrollbar-button:single-button:horizontal:decrement {
  background-image: url("data:image/svg+xml;utf8,<svg xmlns='http://www.w3.org/2000/svg' width='100' height='100' fill='rgb(63, 81, 181)'><polygon points='00,50 50,00 50,100'/></svg>");
}
.gest_risorse {
  --accent: #506ad4;
  --background: white;
  position: relative;
  width: 100%;
  height: 100vh;
  top: 0;
  left: 0;
  text-align: center;
  background-color: white;
  z-index: 1;
  user-select: none;
}

.gest_risorse > main {
  position: relative;
  width: 100%;
}

.gest_risorse > main > section {
  text-align: left !important;
  height: 50px;
  width: 220px;
  border: 1px solid rgb(87, 85, 85);
  position: relative;
  color: var(--accent);
  white-space: nowrap;
  padding-left: 8px;
  background-color: rgb(255, 255, 255);
  z-index: 5;
}

.gest_risorse table {
  text-align: left;
  border-collapse: collapse;
  --cellheight: 40px;
  font-size: 14px;
}

.tabellaSch {
  max-height: calc(100vh - 96px);
  position: relative;
  height: 100%;
  top: -50px;
  width: 100%;
  overflow: scroll;
}

#diagram_table {
  --unit: 100px;
  position: relative;
  background-color: rgb(255, 255, 255);
  border-collapse: collapse;
}

#diagram_table > thead > tr:nth-of-type(1) {
  height: 50px;
}

.head_fix {
  z-index: 2;
}

.head_fix_sotto {
  top: 50px !important;
  z-index: 2;
}

#diagram_table > thead > tr > th {
  text-align: center;
  padding: 3px;
  white-space: nowrap;
  background-color: white;
  border: 1px solid #a3cdd9;
  position: sticky !important;
  top: 0px;
}

#diagram_table > thead > tr:nth-of-type(2) > th:not(.col_attivita) {
  min-width: calc(1px * var(--larghezza_td)) !important;
  max-width: calc(1px * var(--larghezza_td)) !important;
  min-height: 30px !important;
  max-height: 30px !important;
}

#diagram_table > tbody > tr:nth-of-type(odd) {
  background-color: var(--righe_disp_sched);
}

#diagram_table > tbody > tr:nth-of-type(odd) td[extra="0"] {
  background-color: white !important;
}

#diagram_table > tbody > tr:nth-of-type(odd) td[data-itemtype="1"] {
  background-color: var(--righe_disp_sched);
}

.gest_risorse table tr {
  min-height: 30px !important;
  max-height: 30px !important;
  position: relative;
}

.gest_risorse table td:not([data-itemtype="1"]) {
  height: 75px;
  margin-left: 250px;
  border-collapse: collapse;
  border: 1px solid #a3cdd9;
  white-space: nowrap;
  position: relative;
}

#diagram_table td:not([data-itemtype]) {
  color: transparent;
}

#diagram_table td[data-itemtype] {
  overflow: visible;
  padding: 0;
  box-sizing: border-box;
}

/*Correzione della larghezza per tenere in considerazione anche il bordo delle celle*/
#diagram_table td figure {
  position: absolute;
  top: 2.5%;
  left: 0;
  height: 95%;
  --zoomlevel: 3;
  --temp: calc(1px * var(--zoomlevel));
  width: calc((100% * var(--duration)) + ((var(--temp) * (var(--duration)))));
  display: block;
}

#diagram_table td:not([data-itemtype="2"]) > figure > div {
  position: absolute;
  width: 100%;
  height: 100%;
  background-color: var(--colore_sfondo);
  color: var(--colore_testo);
  border-radius: 3px;
  border: 1px solid #172736;
}

#diagram_table td:not([data-itemtype="2"]) > figure > div > span > i.v-icon {
  color: var(--colore_testo) !important;
}

#diagram_table td:not([data-itemtype="2"]) > figure > div > span > button >  i.v-icon{
  color: var(--colore_testo) !important;
}

#diagram_table td > figure > div > span {
  position: relative;
  top: 0;
  left: 0;
  margin: 0;
  padding: 4px 0;
  height: 80%;
  width: 100%;
  overflow: var(--overflow);
  white-space: nowrap;
  text-overflow: ellipsis;
  box-sizing: border-box;
  display: block;
  text-indent: 3px;
}

#td_risorsa {
  border: 1px solid rgba(12, 182, 54, 0.5);
  border-radius: 5px;
  height: 100%;
  text-align: center;
  padding: 0 4px;
  background-color: rgba(23, 114, 46, 0.1);
}

#completamento {
  width: calc(1% * (var(--completamento))) !important;
  height: 10% !important;
  top: 50%;
  background-color: rgba(12, 182, 54, 0.5);
}

#diagram_table td[data-itemtype="0"] {
  position: relative;
  /*height: 100%;*/

  /*display: block;*/
}

#articolo {
  height: 40% !important;
  top: 0 !important;
}

.col_attivita {
  padding-left: 7px !important;
  padding-right: 7px !important;
  position: sticky !important;
  text-align: center;
  left: 0px;
  background-color: white;
  min-width: 220px !important;
  max-width: 220px !important;
  z-index: 3;
  border: 1px solid #a3cdd9;
}

.col_titolo {
  padding-left: 7px !important;
  padding-right: 7px !important;
  height: 35px !important;
  font-size: 17px !important;
  top: 50px !important;
  left: 0px !important;
  z-index: 5 !important;
}

.col_operatori {
  padding-left: 7px !important;
  padding-right: 7px !important;
  position: sticky !important;
  text-align: center;
  left: 0px;
  background-color: white;
  min-width: 220px !important;
  max-width: 220px !important;
  z-index: 2;
  border: 1px solid #a3cdd9;
}

#diagram_table .nome_oper {
  display: var(--nome_vis);
}

#diagram_table .cod_articolo {
  display: var(--cod_art_vis);
}

#diagram_table .des_articolo {
  display: var(--des_art_vis);
}

#diagram_table .cod_commessa {
  display: var(--cod_com_vis);
}

#diagram_table .fase {
  display: var(--cod_num_vis);
}

#diagram_table td[data-itemtype="2"] > figure > div {
  position: absolute;
  width: 100%;
  height: 100%;
  background-color: rgba(223, 110, 110, 0.589);
  border-radius: 3px;
  border: 1px solid #172736;
}
#diagram_table td[data-itemtype="2"] {
  position: relative;
  height: 100%;
  --zoomlevel: 1;
  --temp: calc(1px / var(--zoomlevel));
  width: calc(
    (100% * var(--duration_vinc)) +
      ((var(--temp) * (var(--duration_vinc))) - var(--temp))
  );
  display: block;
}

.tot_operatori {
  position: relative;
  left: 48%;
  font-size: 150%;
}

#calcolo-operatori {
  background-color: rgb(118, 159, 247) !important;
  color: white;
  position: sticky !important;
  top: 77px !important;
  max-height: 45px !important;
  z-index: 5;
}

.titolo-oper {
  font-weight: bold;
  font-size: 20px !important;
  color: white;
  background-color: rgb(118, 159, 247) !important;
}

/*.col_risorsa {
  min-width: 70px ;
  min-height: 25px;
  position: fixed !important;
  background: #a3cdd9;
}
*/

.context-menu {
  position: absolute;
  display: none;
  color: black;
  z-index: 20;
}

.context-menu--active {
  display: block !important;
  padding: 10px;
}

.context-menu-vinc- {
  position: absolute;
  display: none;
  color: black;
}

.context-menu-vinc--active {
  display: block !important;
  padding: 6px;
}
</style>